import React, { useEffect, useState } from "react";
import { fetchApi } from "../../config";

const JOBS = [
    {
        kicker: "ENGINEERING",
        title: "PHP Developer",
        text: "2–8 years with Core PHP and a framework like WordPress, CodeIgniter or Laravel. Strong on HTML, CSS & JavaScript, MySQL, version control and REST/API integrations.",
        meta: ["Full-time", "2–8 yrs", "Jaipur", "5 openings"],
    },
    {
        kicker: "MOBILE",
        title: "React Native Developer",
        text: "Build cross-platform mobile apps with React Native. Comfortable with JavaScript/TypeScript, REST APIs and shipping to both app stores.",
        meta: ["Full-time", "2–6 yrs", "Jaipur"],
    },
    {
        kicker: "MARKETING",
        title: "SEO Specialist",
        text: "Own on-page and off-page SEO, technical audits and content strategy. Data-driven, curious and up to date with search.",
        meta: ["Full-time", "1–5 yrs", "Jaipur"],
    },
    {
        kicker: "ENGINEERING",
        title: "Salesforce Developer",
        text: "Apex, Lightning and integrations. Configure, customise and extend Salesforce for real business workflows.",
        meta: ["Full-time", "2–8 yrs", "Jaipur"],
    },
];

/**
 * @param {(role: string) => void} onApply — preselects the role in the apply form.
 */
export default function JobList({ onApply, vacancies: propVacancies }) {
    const [jobs, setJobs] = useState(() => JOBS);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        // If parent provided vacancies, use them and skip fetching
        if (Array.isArray(propVacancies)) {
            const mapped = propVacancies.map((v) => ({
                kicker: v.job_sub_title || "",
                title: v.job_title || "",
                text: v.job_description || "",
                meta: (v.job_details || "").split(",").map((s) => s.trim()).filter(Boolean),
                id: v.id,
            }));
            setJobs(mapped);
            return;
        }

        let mounted = true;
        async function load() {
            setLoading(true);
            try {
                const res = await fetchApi("get_vacancies.php");
                if (!mounted) return;
                if (res && res.Vacancies && Array.isArray(res.Vacancies)) {
                    const mapped = res.Vacancies.map((v) => ({
                        kicker: v.job_sub_title || "",
                        title: v.job_title || "",
                        text: v.job_description || "",
                        meta: (v.job_details || "").split(",").map((s) => s.trim()).filter(Boolean),
                        id: v.id,
                    }));
                    setJobs(mapped);
                } else {
                    setError("No vacancies returned from API");
                }
            } catch (err) {
                setError(err.message || "Failed to load vacancies");
            } finally {
                setLoading(false);
            }
        }
        load();
        return () => {
            mounted = false;
        };
    }, [propVacancies]);

    return (
        <section className="section container" id="careers">
            <h2 className="h-lg section-title">Current openings.</h2>
            {loading && <p>Loading vacancies…</p>}
            {error && <p className="form-note">Error: {error}</p>}
            <div className="job-list">
                {jobs.map((job) => (
                    <article className="job-card card" key={job.id || job.title}>
                        <div className="job-main">
                            <span className="kicker">{job.kicker}</span>
                            <h3>{job.title}</h3>
                            <p dangerouslySetInnerHTML={{ __html: job.text }} />
                            <div className="job-meta">
                                {job.meta.map((m) => (
                                    <span key={m}>{m}</span>
                                ))}
                            </div>
                        </div>
                        <button
                            className="btn btn-primary btn--sm"
                            onClick={() => onApply && onApply(job.title)}
                            type="button"
                        >
                            Apply now
                        </button>
                    </article>
                ))}
            </div>
        </section>
    );
}

export { JOBS };
